<app-modal title="Annuler la reddition" size="sm" closeLabel="Fermer" (closed)="close()">
  <form [formGroup]="annulationForm">
    @if (infosRedditionEnCours(); as infosReddition) {
      <p>
        Voulez-vous annuler la reddition de
        <strong>{{ infosReddition.montantAReverserHT | devise }}</strong> (dont
        {{ infosReddition.montantCommissionHT | devise }} de commission) pour la formule
        <strong>{{ infosReddition.nom }} - {{ infosReddition.idAparte }}</strong>
      </p>
    }

    <app-form-field label="Commentaire" [required]="true">
      <app-input multiline [rows]="3" formControlName="commentaire" />
      @if (annulationFormSuivi().controls.commentaire.hasError('required')) {
        <span appFieldError>Le commentaire est obligatoire</span>
      }
      @if (annulationFormSuivi().controls.commentaire.hasError('minlength')) {
        <span appFieldError>Le commentaire doit faire au minimum 3 caractères</span>
      }
    </app-form-field>
  </form>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="close()">Non</button>
    <button
      type="button"
      appButton
      variant="primary"
      [disabled]="!annulationFormSuivi().valid || !infosRedditionEnCours()"
      (click)="submit()"
    >
      Oui
    </button>
  </div>
</app-modal>
